export const isNumber = (text) => /^\d+$/.test(text);
export const isFloat = (text) => /^-?([0-9]*[.])?([0-9]+)?$/.test(text);
export const emojiExpression = /\p{Extended_Pictographic}/gu;
export const isTime = (text) => /^\d*:?\d*$/.test(text);
export const asianCharsRegExp = /[\u3400-\u9FBF]/;

export const changeInputRegexp =
  (callbackRegExp, callbackResult, canBeEmpty = false) =>
  (e) => {
    if (callbackRegExp(e.target.value) || (canBeEmpty && !e.target.value)) callbackResult(e.target.value);
  };
